import React from "react";
import { motion } from "framer-motion";
import { itemVariants } from "../../constants/animations";

export interface SkillBarProps {
  name: string;
  level: number;
  color: string;
  icon: React.ReactNode;
  delay: number;
}

const SkillBar: React.FC<SkillBarProps> = ({
  name,
  level,
  color,
  icon,
  delay,
}) => (
  <motion.div variants={itemVariants} className="glass rounded-xl p-4">
    <div className="flex items-center gap-4 mb-3">
      <span className="text-2xl" style={{ color }}>
        {icon}
      </span>
      <span className="font-medium">{name}</span>
      <span className="ml-auto text-slate-400">{level}%</span>
    </div>
    <div className="h-3 bg-slate-700 rounded-full overflow-hidden skill-bar">
      <motion.div
        initial={{ width: 0 }}
        whileInView={{ width: `${level}%` }}
        transition={{ duration: 1, delay }}
        viewport={{ once: true }}
        className="h-full rounded-full"
        style={{ background: `linear-gradient(90deg, ${color}, ${color}88)` }}
      />
    </div>
  </motion.div>
);

export default SkillBar;
